
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Form,Input, Layout, Menu, Space, Card, Carousel,Button,Typography,Modal  } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';
import MyComp from '../comp/my-comp.js';


export default class App extends MyComp{
  constructor(props) {
    super(props);
    this.state = {
      winWidth: 0,
      winHeight: 100,
    }

  }


  getBody(){
    return (
      <Space size={0} direction='vertical' style={{width: '100vw', padding:0,margin:0}}>
        {this.getCompany1()}
      </Space>
    )
  }
  render() {
    return (
      <div >
        {this.getBody()}
      </div>
    );
  }
}

